/**
 * Convert an arbitrary object into an object of entries for firebase realtime database
 * example:
 * const from = {
 *  prop1: "a",
 *  prop2: [1,2],
 *  prop3: {
 *    x: 10,
 *    bar: {
 *      foo: 'value'
 *    }
 *   }
 * }
 * const entries = objectToEntries(from, {}, 'prefix/')
 * entries -->
 * {
 *  'prefix/prop1/': "a",
 *  'prefix/prop2/0/': 1,
 *  'prefix/prop2/1/': 2,
 *  'prefix/prop3/x/': 10,
 *  'prefix/prop3/bar/foo/': 'value'
 * }
 */

/**
 * @param prefix
 * @param fromObject
 * @param toObject
 * @return {{}}
 */
export function objectToEntries (fromObject, toObject, prefix) {
  const entries = Object.entries(fromObject)
  if (!entries.length) {
    toObject[prefix] = {}
    return toObject
  }
  return Object.entries(fromObject).reduce((to, [key, value]) => {
    return valueToEntries(value, to, prefix + key + '/')
  }, toObject)
}

/**
 * @param {[]} fromArray
 * @param {{}} toObject
 * @param {string} prefix
 * @return {{}}
 */
export function arrayToEntries (fromArray, toObject, prefix) {
  if (!fromArray.length) {
    toObject[prefix] = []
    return toObject
  }
  return fromArray.reduce((to, value, i) => {
    return valueToEntries(value, to, prefix + i + '/')
  }, toObject)
}

/**
 * @param {*} value
 * @param {{}} toObject
 * @param {string} prefix
 * @return {{}}
 */
export function valueToEntries (value, toObject, prefix) {
  if (Array.isArray(value)) {
    return arrayToEntries(value, toObject, prefix)
  } else if (typeof value === 'object' && value !== null) {
    return objectToEntries(value, toObject, prefix)
  } else {
    toObject[prefix] = value
    return toObject
  }
}
